import useCreateOrderSheetSeamlesslyFetcher from "@/features/line-sheet-sets/hooks/use-create-order-sheet-seamlessly-fetcher";
import useYWRInfinite from "@/features/ui/hooks/use-ywr-inifite";
import { createOrderSheetSeamlesslyKey } from "@/features/line-sheet-sets/hooks/use-create-order-sheet-seamlessly";

export default function useCreateOrderSheetSeamlesslyInfinite() {
  const fetcher = useCreateOrderSheetSeamlesslyFetcher();
  return useYWRInfinite(createOrderSheetSeamlesslyKey, fetcher);
}
